import React from "react";
import { Text } from "@merge-api/merge-javascript-shared";

type Props = {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  badge?: string | JSX.Element;
};

const DashboardOnboardingHeader = ({ title, subtitle, badge }: Props) => {
  return (
    <div className="flex flex-col gap-y-4 items-start pb-6">
      {badge ? (
        <div className="flex items-center gap-4">
          <Text variant="h2">{title}</Text>
          <span className="w-6 border-b border-gray-10" />
          <Text variant="pre-title">{badge}</Text>
          <span className="flex-grow" />
        </div>
      ) : (
        <Text variant="h2">{title}</Text>
      )}
      {subtitle && <Text>{subtitle}</Text>}
    </div>
  );
};

export default DashboardOnboardingHeader;
